<template>
  <div>
    <v-card class="mb-2 elevation-0">
      <v-layout justify-center row wrap>
        <v-flex
          xs12
          sm6
          md5
          lg4
          ma-3
          v-for="(ally) in allies"
          :key="ally.id"
        >
          <payment-ally
            :ally="ally"
            :defaultSeleted="ally.active_costs[0].id"
            :enrollment_status_id="enrollment_status_id"
            :enrollment_id="enrollment_status.enrollment_id"
            :student_id="enrollment_status.student_id"
            :family_id="student.family_id"
            v-on:toggleChecked="toggleChecked"
            v-on:refreshData="init"
          >
          </payment-ally>
        </v-flex>
      </v-layout>
      <v-layout row justify-center mt-3>
        <v-btn flat @click="goToPrevStep">{{ $t(`enrollments.back`) }}</v-btn>
        <v-btn
            color="primary"
            @click="goToNextStep"
            :disabled="!canContinue"
        >
        {{ $t(`enrollments.next`) }}
        </v-btn>
      </v-layout>
    </v-card>
  </div>
</template>

<script>
  import axios from 'axios';
  import PaymentAlly from './payment_ally.vue';
  import { mapGetters } from 'vuex'
  export default {
    name: 'enrollment-step-4-allies',
    components: {
      'payment-ally': PaymentAlly,
    },
    data() {
      return {
        allies: [],
        checked: 0,
      }
    },
    created () {
      // this.init()
    },
    computed: {
      ...mapGetters({
        enrollment_status_id: 'currentEnrollmentStatusId',
        enrollment_status: 'currentEnrollment',
        student: 'currentEnrollmentStudent',
      }),
      canContinue() {
        let canContinue = false
        if (this.checked === 0) {
          canContinue = true
        }
        if (!canContinue) {
          const alliesPaid = this.allies.filter(ally => {
            let allyPaid = false
            if (ally.payment.payment_state === 'APPROVED') {
              allyPaid = true
            }
            return allyPaid
          })

          canContinue = this.checked - alliesPaid.length === 0
        }
        return canContinue
      }
    },
    watch: {
      enrollment_status(newValue, oldValue) {
        if (newValue.enrollment_id && this.student.family_id) {
          this.init()
        }
      },
    },
    methods: {
      async init() {
        const enrollment_id = this.enrollment_status.enrollment_id
        const family_id = this.student.family_id
        console.log(this.student, this.enrollment_status)
        const result = await axios.get(`/api/enrollment/allies/${family_id}/${enrollment_id}`);
        const allies_payments = result.data.allies_payments;
        this.allies = result.data.allies
          .filter(a => a.enable_for_payment == 1 && a.active_costs.length > 0)
          .map(ally => {
            const payment = allies_payments.filter(p => p.allies_id == ally.id)
              .sort((pa, pb) => pb.id - pa.id)
            return {
              ...ally,
              payment: payment.length > 0 ? { ...payment[0].payment } : {},
            }
          })
        this.checked = this.allies.length
      },
      toggleChecked(step) {
        this.checked = this.checked + step
      },
      goToPrevStep() {
        this.$emit('goToPrevStep', 4)
      },
      goToNextStep() {
        this.$emit('goToNextStep', 6)
      },
    },
  }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/enrollment/enrollment_step4_allies.vue